"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const registries_1 = require("../registries");
registries_1.functionRegistry.set('#', () => '');
